import React, { Component } from "react";
import { connect } from "react-redux";

import "./styles.scss";

// images
import gelPrediction from "./img/gel-prediction-46.svg";

import { fetchTranslations } from "./locales/config";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { injectIntl, FormattedMessage } from "react-intl";

import resultLane1 from "./img/result-lane-1.svg";
import resultLane2 from "./img/result-lane-2.svg";
import resultLane3 from "./img/result-lane-3.svg";
import resultLane4 from "./img/result-lane-4.svg";
import resultLane5 from "./img/result-lane-5.svg";
import resultWhole1 from "./img/result-whole-1.svg";
import resultWhole2 from "./img/result-whole-2.svg";
import resultWhole3 from "./img/result-whole-3.svg";
import resultWhole4 from "./img/result-whole-4.svg";
import resultWhole5 from "./img/result-whole-5.svg";

import plasmid1 from "./img/1.svg";
import plasmid2 from "./img/2.svg";
import plasmid3 from "./img/3.svg";
import plasmid4 from "./img/4.svg";
import plasmid5 from "./img/5.svg";
import plasmid6 from "./img/6.svg";
import plasmid7 from "./img/7.svg";
import plasmid8 from "./img/8.svg";
import plasmid9 from "./img/9.svg";
import plasmid10 from "./img/10.svg";

const plasmids = {
  "754 bp": plasmid1,
  "1184 bp": plasmid2,
  "1614 bp": plasmid3,
  "pARA 4872 bp": plasmid4,
  "5082 bp": plasmid5,
  "pARA-R 5302 bp": plasmid6,
  "pKAN-R 5512 bp": plasmid7,
  "8990 bp": plasmid8,
  "9200 bp": plasmid9,
  "9410 bp": plasmid10,
};

const idealbands = {
  lane1: [
    { label: "10000 bp", height: 15 },
    { label: "8000 bp", height: 56 },
    { label: "6000 bp", height: 92 },
    { label: "5000 bp", height: 124 },
    { label: "4000 bp", height: 156 },
    { label: "3000 bp", height: 204 },
    { label: "2000 bp", height: 272 },
    { label: "1500 bp", height: 306 },
    { label: "1000 bp", height: 384 },
    { label: "500 bp", height: 472 },
  ],
  lane2: [
    { label: "Multimer", height: 15 },
    { label: "Nicked", height: 90 },
    { label: "Supercoiled", height: 120 },
  ],
  lane3: [
    { label: "4705 bp", height: 134 },
    { label: "807 bp", height: 410 },
  ],
  lane4: [
    { label: "Multimer", height: 15 },
    { label: "Nicked", height: 90 },
    { label: "Supercoiled", height: 120 },
  ],
  lane5: [
    { label: "4495 bp", height: 129 },
    { label: "377 bp", height: 487 },
  ],
  lane6: [
    { label: "9410 bp", height: 20 },
    { label: "9200 bp", height: 33 },
    { label: "8990 bp", height: 46 },
    { label: "5512 bp", height: 95 },
    { label: "5302 bp", height: 108 },
    { label: "5082 bp", height: 121 },
    { label: "4872 bp", height: 134 },
    { label: "1614 bp", height: 287 },
    { label: "1184 bp", height: 360 },
    { label: "754 bp", height: 428 },
  ],
};

const images = {
  resultLane1: resultLane1,
  resultLane2: resultLane2,
  resultLane3: resultLane3,
  resultLane4: resultLane4,
  resultLane5: resultLane5,
  resultWhole1: resultWhole1,
  resultWhole2: resultWhole2,
  resultWhole3: resultWhole3,
  resultWhole4: resultWhole4,
  resultWhole5: resultWhole5,
};

class Results46 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedTab: "gK-",
      focusedTabNum: 1,
      tabs: [
        {
          title: "gK-",
          lane: 1,
        },
        {
          title: "gK+",
          lane: 2,
        },
        {
          title: "gA-",
          lane: 3,
        },
        {
          title: "gA+",
          lane: 4,
        },
        {
          title: "gLIG",
          lane: 5,
        },
      ],
    };
  }

  getPredictionLaneClass = (lane) => {
    if (lane === this.state.focusedTabNum + 1) {
      return "band-prediction__lane band-prediction--focused";
    } else {
      return "band-prediction__lane band-prediction--unfocused";
    }
  };

  mapHeightToSecondRange(itemHeight) {
    // Define the start and end points of both ranges
    const firstRangeStart = 20;
    const firstRangeEnd = 630;
    const secondRangeStart = 0;
    const secondRangeEnd = 461;

    // Calculate the height in the second range
    const secondHeight =
      secondRangeStart +
      ((itemHeight - firstRangeStart) * (secondRangeEnd - secondRangeStart)) /
        (firstRangeEnd - firstRangeStart);

    // Ensure the calculated height is within the second range's bounds
    return Math.min(Math.max(secondHeight, secondRangeStart), secondRangeEnd);
  }

  generatePredictedLaneBands = () => {
    const renderBands = [];
    const renderRef = [];

    //Gets all band data for focused lane
    const bandData =
      this.props.predictedBands["lane" + (this.state.focusedTabNum + 1)];

    const ref = this.props.predictedBands["lane" + 1];

    //TODO: fix styling to take band height

    let counter = 0;
    for (let i = 0; i < bandData.length; i++) {
      const band = bandData[i];
      renderBands.push(
        <div
          className="predicted-bands__gel-band"
          style={{ top: this.mapHeightToSecondRange(band.height) + "px" }}
          key={i}
        >
          {band.label}
        </div>
      );
    }

    counter = 0;
    for (const band in ref) {
      if (ref[band].height > 0) {
        renderRef.push(
          <div
            className="predicted-bands__gel-band"
            style={{ top: ref[band].height * 0.93 + "px" }}
            key={counter}
          >
            {ref[band].label}
          </div>
        );
      }
      counter++;
    }

    return (
      <div>
        <div className="predicted-bands">{renderRef}</div>
        <div className="predicted-bands">{renderBands}</div>
      </div>
    );
  };

  generateIdealLaneBands = () => {
    const renderBands = [];
    const renderRef = [];

    //Gets all band data for focused lane
    const bandData = idealbands["lane" + (this.state.focusedTabNum + 1)];

    const ref = idealbands["lane" + 1];

    let counter = 0;
    for (let i = 0; i < bandData.length; i++) {
      const band = bandData[i];
      renderBands.push(
        <div
          className="predicted-bands__gel-band"
          style={{ top: band.height * 0.93 + "px" }}
          key={i}
        >
          {band.label}
        </div>
      );
    }

    counter = 0;
    for (const band in ref) {
      if (ref[band].height > 0) {
        renderRef.push(
          <div
            className="predicted-bands__gel-band"
            style={{ top: ref[band].height * 0.93 + "px" }}
            key={counter}
          >
            {ref[band].label}
          </div>
        );
      }
      counter++;
    }

    return (
      <div>
        <div className="predicted-bands">{renderRef}</div>
        <div className="predicted-bands">{renderBands}</div>
      </div>
    );
  };

  generateResultLaneBands = () => {
    const renderBands = [];
    const renderRef = [];

    //Gets all band data for focused lane
    const bandData =
      this.props.resultBands["lane" + (this.state.focusedTabNum + 1)];

    const ref = this.props.resultBands["lane" + 1];

    let counter = 0;
    for (const band in bandData) {
      if (bandData[band] > 0) {
        renderBands.push(
          <div
            className="result-bands__gel-band"
            style={{ top: bandData[band] * 0.93 + "px" }}
            key={counter}
          >
            {band}
          </div>
        );
      }
      counter++;
    }

    counter = 0;
    for (const band in ref) {
      if (ref[band] > 0) {
        renderRef.push(
          <div
            className="result-bands__gel-band"
            style={{ top: ref[band] * 0.93 + "px" }}
            key={counter}
          >
            {band}
          </div>
        );
      }
      counter++;
    }

    return (
      <div>
        <div className="result-bands">{renderRef}</div>
        <div className="result-bands">{renderBands}</div>
      </div>
    );
  };

  generateResultGel = () => {
    const renderLanes = [[], [], [], [], [], []];
    const renderGel = [];

    //Gets all band data for focused lane
    const bandData = this.props.resultBands;

    //Creates all bands and inserts into correct arrays in renderLanes
    for (let j = 1; j < 7; j++) {
      let counter = 0;
      for (const band in bandData["lane" + j]) {
        if (bandData["lane" + j][band] !== 0) {
          if (j === 1) {
            renderLanes[j - 1].push(
              <div
                className="band-prediction__lane--gel-band"
                style={{
                  position: "absolute",
                  top: bandData["lane" + j][band] * 0.36 + 7 + "px",
                }}
                key={counter * j * (j + 1)}
              ></div>
            );
          } else if (j === 6) {
            renderLanes[j - 1].push(
              <div
                className="band-prediction__lane--gel-band"
                style={{
                  position: "absolute",
                  top: bandData["lane" + j][band] * 0.36 + 11 + "px",
                }}
                key={counter * j * (j + 1)}
              ></div>
            );
          } else {
            renderLanes[j - 1].push(
              <div
                className="band-prediction__lane--gel-band"
                style={{
                  position: "absolute",
                  top: bandData["lane" + j][band] * 0.36 + "px",
                }}
                key={counter * j * (j + 1)}
              ></div>
            );
          }
        }
        counter++;
      }
    }

    //Takes all bands in renderLanes and fits them in divs in renderGel
    for (let i = 0; i < 6; i++) {
      renderGel.push(
        <div className={this.getPredictionLaneClass(i + 1)}>
          {renderLanes[i]}
        </div>
      );
    }

    //Returns all bands, in their divs
    return <div className="band-prediction right">{renderGel}</div>;
  };

  generatePredictedGel = () => {
    const renderLanes = [[], [], [], [], [], []];
    const renderGel = [];

    //Gets all band data for focused lane
    const bandData = this.props.predictedBands;

    //Creates all bands and inserts into correct arrays in renderLanes
    for (let j = 1; j < 7; j++) {
      for (let i = 0; i < bandData["lane" + j].length; i++) {
        const band = bandData["lane" + j][i];
        //Extra offset for first ladder lane - to fix bands appearing in gel holes
        if (j === 1) {
          renderLanes[j - 1].push(
            <div
              className="band-prediction__lane--gel-band"
              style={{
                position: "absolute",
                top: band.height * 0.36 + 7 + "px",
              }}
              key={i * j * (j + 1)}
            ></div>
          );
        } else {
          renderLanes[j - 1].push(
            <div
              className="band-prediction__lane--gel-band"
              style={{ position: "absolute", top: band.height * 0.36 + "px" }}
              key={i * j * (j + 1)}
            ></div>
          );
        }
      }
    }

    //Takes all bands in renderLanes and fits them in divs in renderGel
    for (let i = 0; i < 6; i++) {
      renderGel.push(
        <div className={this.getPredictionLaneClass(i + 1)}>
          {renderLanes[i]}
        </div>
      );
    }

    //Returns all bands, in their divs
    return <div className="band-prediction">{renderGel}</div>;
  };

  renderFocusedTab = () => {
    const resultTab = (
      <div className="focusedTabContainer">
        <div className="column">
          <div className="column__left">
            <p className="label">
              <FormattedMessage
                id="Predicted results"
                defaultMessage="Predicted results"
                description=""
              />
            </p>

            <div className="column__left--predicted">
              <img
                src={gelPrediction}
                alt={
                  <FormattedMessage
                    id="Predicted results"
                    defaultMessage="Predicted results"
                    description=""
                  />
                }
              />
              {this.generatePredictedGel()}
            </div>
          </div>

          <div className="column__right">
            <p className="label">
              {this.state.focusedTab}
              <FormattedMessage
                id="Predicted results"
                defaultMessage="Predicted results"
                description=""
              />
            </p>

            <div
              className="column__left--predicted"
              style={{ position: "relative" }}
            >
              {this.generatePredictedLaneBands()}
            </div>
          </div>
        </div>
        <div className="column">
          <div className="column__left">
            <p className="label">
              <FormattedMessage
                id="Actual results"
                defaultMessage="Actual results"
                description=""
              />
            </p>
            <div className="column__right--actual">
              <img
                src={gelPrediction}
                alt={
                  <FormattedMessage
                    id="Actual results"
                    defaultMessage="Actual results"
                    description=""
                  />
                }
              />
              {this.generateResultGel()}
            </div>
          </div>

          <div className="column__right">
            <p className="label">
              {this.state.focusedTab}
              <FormattedMessage
                id="Actual results"
                defaultMessage="Actual results"
                description=""
              />
            </p>

            <div className="column__left--predicted">
              {this.generateResultLaneBands()}
            </div>
          </div>
        </div>

        <div className="column">
          <div className="column__left">
            <p className="label resultsHeading">
              <FormattedMessage
                id="Ideal results"
                defaultMessage="Ideal results"
                description=""
              />
            </p>
            <img
              style={{ marginTop: "15px" }}
              className="resultsImg"
              src={images["resultWhole" + this.state.focusedTabNum]}
              alt={
                <FormattedMessage
                  id="Ideal results"
                  defaultMessage="Ideal results"
                  description=""
                />
              }
            />
            <div style={{ paddingTop: "25px" }}></div>
          </div>

          <div className="column__right">
            <p className="label resultsHeading">
              {this.state.focusedTab}
              <FormattedMessage
                id="Ideal results"
                defaultMessage="Ideal results"
                description=""
              />
            </p>
            <div
              className="column__left--predicted"
              style={{ position: "relative" }}
            >
              {this.generateIdealLaneBands()}
            </div>
          </div>
        </div>
      </div>
    );

    return resultTab;
  };

  selectTab = (title) => {
    const keys = {
      "gK-": 1,
      "gK+": 2,
      "gA-": 3,
      "gA+": 4,
      gLIG: 5,
    };

    this.setState({
      focusedTab: title,
      focusedTabNum: keys[title],
    });
  };

  fragmentAlt = (index) => {
    const alts = {
      "754 bp": this.props.intl.formatMessage({
        id: "Plasmid showing no fragments.",
        defaultMessage: "Plasmid showing no fragments.",
        description: "",
      }),
      "1184 bp": this.props.intl.formatMessage({
        id: "Plasmid showing rfp and pbad fragments with unequal segmentation between fragments.",
        defaultMessage:
          "Plasmid showing rfp and pbad fragments with unequal segmentation between fragments.",
        description: "",
      }),
      "1614 bp": this.props.intl.formatMessage({
        id: "Plasmid showing rfp and pbad fragments with equal segmentation between fragments.",
        defaultMessage:
          "Plasmid showing rfp and pbad fragments with equal segmentation between fragments.",
        description: "",
      }),
      "pARA 4872 bp": this.props.intl.formatMessage({
        id: "Plasmid showing araC, ori and ampR fragments.",
        defaultMessage: "Plasmid showing araC, ori and ampR fragments.",
        description: "",
      }),
      "5082 bp": this.props.intl.formatMessage({
        id: "Plasmid showing kanR fragment.",
        defaultMessage: "Plasmid showing kanR fragment.",
        description: "",
      }),
      "pARA-R 5302 bp": this.props.intl.formatMessage({
        id: "Plasmid showing araC, orim ampR, rfp and pBad fragments.",
        defaultMessage:
          "Plasmid showing araC, orim ampR, rfp and pBad fragments.",
        description: "",
      }),
      "pKAN-R 5512 bp": this.props.intl.formatMessage({
        id: "Plasmid showing rfp, pbad and kanR fragments.",
        defaultMessage: "Plasmid showing rfp, pbad and kanR fragments.",
        description: "",
      }),
      "8990 bp": this.props.intl.formatMessage({
        id: "Plasmid showing two araC, ori and ampR fragments.",
        defaultMessage: "Plasmid showing two araC, ori and ampR fragments.",
        description: "",
      }),
      "9200 bp": this.props.intl.formatMessage({
        id: "Plasmid showing kanR, araC, ori and ampR fragments.",
        defaultMessage: "Plasmid showing kanR, araC, ori and ampR fragments.",
        description: "",
      }),
      "9410 bp": this.props.intl.formatMessage({
        id: "Plasmid showing two kanR fragments.",
        defaultMessage: "Plasmid showing two kanR fragments.",
        description: "",
      }),
    };

    return alts[index];
  };

  render() {
    return (
      <div className="Results">
        <div className="question">
          <h4
            style={{
              marginTop: "0px",
              fontSize: "20px",
              fontFamily: "'DIN Alternate',Arial,sans-serif",
            }}
          >
            <FormattedMessage
              id="What plasmid in the gLIG tube is the one we are looking for?"
              defaultMessage="What plasmid in the gLIG tube is the one we are looking for?"
              description=""
            />
          </h4>
          <div>
            <FormattedMessage
              id="Your answer:"
              defaultMessage="Your answer:"
              description=""
            />
          </div>
          <div className="result">
            <img
              alt={
                this.props.predictedPlasmid !== ""
                  ? this.fragmentAlt(this.props.predictedPlasmid)
                  : null
              }
              src={
                this.props.predictedPlasmid !== ""
                  ? plasmids[this.props.predictedPlasmid]
                  : null
              }
            />
          </div>

          <div>
            <FormattedMessage
              id="Ideal answer:"
              defaultMessage="Ideal answer:"
              description=""
            />
          </div>
          <div className="result">
            <img
              alt={this.fragmentAlt("pARA-R 5302 bp")}
              src={plasmids["pARA-R 5302 bp"]}
            />
          </div>
        </div>

        <div className="menu">
          <ul className="menu__header">
            {this.state.tabs.map((item) => (
              <li
                className={
                  "menu__header--tab" +
                  (item.title === this.state.focusedTab
                    ? " menu__header--tab-active"
                    : "")
                }
                role="option"
                aria-selected={item.title}
                tabIndex={0}
                onClick={() => this.selectTab(item.title)}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.keyCode === 32)
                    this.selectTab(item.title);
                }}
              >
                {item.title}
              </li>
            ))}
          </ul>

          <div className="menu__content">{this.renderFocusedTab()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    predictedPlasmid: state.predictions.dropDownChoice,
    predictedBands: state.predictions,
    resultBands: {
      lane1: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
      lane2: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
      lane3: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
      lane4: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
      lane5: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
      lane6: {
        377: 0,
        500: 0,
        754: 0,
        807: 0,
        1000: 0,
        1184: 0,
        1500: 0,
        1614: 0,
        2000: 0,
        3000: 0,
        4000: 0,
        4495: 0,
        4705: 0,
        4872: 0,
        5000: 0,
        5082: 0,
        5302: 0,
        5512: 0,
        6000: 0,
        8000: 0,
        8990: 0,
        9200: 0,
        9410: 0,
        10000: 0,
        Multimer: 0,
        Nicked: 0,
        Supercoiled: 0,
      },
    },
  };
};

const ComponentWithIntl = injectIntl(Results46);

export default connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ComponentWithIntl {...props} />
  </TranslationsProvider>
));
